.toolbar {
  display: flex;
  align-items: center;
  padding-bottom: var(--space-lg);
  min-height: 4.5rem;
}

.toolbarSection {
  display: flex;
  gap: var(--space-md-lg);

  &.start {
    /* default aligned at the start */
  }

  &.center {
    margin-left: auto;
    margin-right: auto;
  }

  &.end {
    margin-left: auto;
  }
}
